/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imagesGetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGet } from "../../funcs/imagesGetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest$inboundSchema,
};

export const tool$imagesGetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGet:
  ToolDefinition<typeof args> = {
    name: "ledger-image-v1",
    description: `Original tool name: images-get-ledger-image-api-v1-images-ledgers-ledger-canister-id-png-get

Get open graph image for ICRC ledger`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await imagesGetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };